/* PF Mega Menu v6.3 — free Globo replacement. Disclosure-pattern navigation with hover intent. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pfmmReady) return;
    root.dataset.pfmmReady = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('.pfmm__item--parent'));
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var openItem = null;
    var openTimer = null;
    var closeTimer = null;
    var GAP = 34;
    var MIN_COL = 150;
    var MAX_COL = 240;
    var STACK_GAP = 22;
    // v5: dim the page behind an open mega panel. One shared element per page.
    var backdrop = null;
    if (root.hasAttribute('data-dim')) {
      backdrop = document.querySelector('.pfmm-backdrop');
      if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.className = 'pfmm-backdrop';
        backdrop.setAttribute('aria-hidden', 'true');
        document.body.appendChild(backdrop);
      }
      backdrop.addEventListener('click', function () { if (openItem) setOpen(openItem, false); });
    }
    function dim(on) { if (backdrop) backdrop.classList.toggle('is-on', !!on); }

    // Order-preserving split of column heights into at most k stacks, minimising the tallest stack.
    function partition(h, k) {
      var n = h.length, best = null;
      function total(g) {
        var s = 0;
        for (var i = 0; i < g.length; i++) s += h[g[i]];
        return s + STACK_GAP * (g.length - 1);
      }
      function rec(i, groups, cur) {
        if (groups.length + 1 > k) return;
        if (i === n) {
          var all = groups.concat([cur]);
          var m = Math.max.apply(null, all.map(total));
          if (!best || m < best.m || (m === best.m && all.length > best.g.length)) best = { m: m, g: all };
          return;
        }
        rec(i + 1, groups, cur.concat([i]));
        rec(i + 1, groups.concat([cur]), [i]);
      }
      rec(1, [], [0]);
      return best.g;
    }

    // Balance a mega panel's columns into stacks so the panel is as short as possible.
    function pack(panel) {
      var cols = panel.querySelector('.pfmm__cols');
      if (!cols || !panel.parentNode.classList.contains('pfmm__item--mega')) return;
      var w = Math.round(cols.getBoundingClientRect().width);
      if (!w || cols.getAttribute('data-pfmm-w') === String(w)) return;
      Array.prototype.slice.call(cols.querySelectorAll('.pfmm__stack')).forEach(function (s) {
        while (s.firstChild) cols.insertBefore(s.firstChild, s);
        cols.removeChild(s);
      });
      var items = Array.prototype.filter.call(cols.children, function (e) { return e.classList.contains('pfmm__col'); });
      cols.setAttribute('data-pfmm-w', String(w));
      if (items.length < 2) { cols.style.gridTemplateColumns = ''; return; }
      // v5: try every column count from wide to narrow columns and keep the one that gives the shortest panel
      // (narrow columns wrap long link names, wide ones leave fewer stacks).
      var kmax = Math.min(items.length, Math.max(1, Math.floor((w + GAP) / (MIN_COL + GAP))));
      var kmin = Math.min(kmax, Math.max(1, Math.floor((w + GAP) / (MAX_COL + GAP))));
      var best = null;
      for (var k = kmax; k >= kmin; k--) {
        cols.style.gridTemplateColumns = 'repeat(' + k + ', minmax(0, 1fr))';
        var h = items.map(function (e) { return e.getBoundingClientRect().height; });
        var g = partition(h, k);
        var tallest = Math.max.apply(null, g.map(function (grp) {
          var t = 0;
          for (var i = 0; i < grp.length; i++) t += h[grp[i]];
          return t + STACK_GAP * (grp.length - 1);
        }));
        if (!best || tallest < best.m - 1) best = { m: tallest, g: g };
      }
      var groups = best.g;
      var n = groups.length;
      var colW = Math.floor((w - GAP * (n - 1)) / n);
      // Few columns in a wide panel: keep them compact instead of stretching across the page.
      cols.style.gridTemplateColumns = colW > 280 ? 'repeat(' + n + ', 280px)' : 'repeat(' + n + ', minmax(0, 1fr))';
      groups.forEach(function (g) {
        var stack = document.createElement('div');
        stack.className = 'pfmm__stack';
        g.forEach(function (j) { stack.appendChild(items[j]); });
        cols.appendChild(stack);
      });
    }

    // Mega panels span the full window width; small dropdowns stay inside the window.
    function place(panel) {
      var vw = document.documentElement.clientWidth;
      if (panel.parentNode.classList.contains('pfmm__item--mega')) {
        var r = root.getBoundingClientRect();
        panel.style.left = (-Math.round(r.left)) + 'px';
        panel.style.right = (-Math.round(vw - r.right)) + 'px';
      } else {
        panel.style.left = '';
        panel.style.right = '';
        if (panel.getBoundingClientRect().right > vw - 8) {
          panel.style.left = 'auto';
          panel.style.right = '0';
        }
      }
    }

    // Keep the open panel inside the viewport; it scrolls internally only if it still cannot fit.
    function fit(panel) {
      var top = panel.getBoundingClientRect().top;
      panel.style.maxHeight = Math.max(240, Math.floor(window.innerHeight - top - 12)) + 'px';
    }

    // Long department names (e.g. USI): shrink the top labels just enough to keep the bar on one line.
    function fitTop() {
      var tops = Array.prototype.filter.call(root.children, function (li) { return li.tagName === 'LI'; })
        .map(function (li) { return li.querySelector('.pfmm__top'); }).filter(Boolean);
      tops.forEach(function (t) { t.style.fontSize = ''; t.style.paddingLeft = ''; t.style.paddingRight = ''; });
      if (!root.clientWidth || !tops.length) return;
      var size = parseFloat(getComputedStyle(tops[0]).fontSize);
      var pad = parseFloat(getComputedStyle(tops[0]).paddingLeft);
      // Measure the labels themselves: an open full-width panel also widens root.scrollWidth.
      function needed() { return tops.reduce(function (sum, t) { return sum + t.getBoundingClientRect().width; }, 0); }
      var guard = 0;
      while (needed() > root.clientWidth - 2 && size > 13 && guard++ < 40) {
        size -= 0.5;
        pad = Math.max(4, pad - 0.5);
        tops.forEach(function (t) { t.style.fontSize = size + 'px'; t.style.paddingLeft = pad + 'px'; t.style.paddingRight = pad + 'px'; });
      }
    }

    function layout(li) {
      var panel = li.querySelector('.pfmm__panel');
      if (!panel) return;
      place(panel);
      pack(panel);
      fit(panel);
    }

    function setOpen(li, open) {
      var trigger = li.querySelector('.pfmm__top');
      li.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        if (openItem && openItem !== li) setOpen(openItem, false);
        openItem = li;
        hydrate(li);
        layout(li);
        dim(li.classList.contains('pfmm__item--mega'));
      } else if (openItem === li) {
        openItem = null;
        dim(false);
      }
    }

    items.forEach(function (li) {
      var trigger = li.querySelector('.pfmm__top');
      if (!trigger) return;

      if (canHover) {
        li.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          clearTimeout(openTimer);
          openTimer = setTimeout(function () { setOpen(li, true); }, openItem ? 0 : 90);
        });
        li.addEventListener('mouseleave', function () {
          clearTimeout(openTimer);
          closeTimer = setTimeout(function () { setOpen(li, false); }, 180);
        });
      }

      trigger.addEventListener('click', function (event) {
        var isOpen = li.classList.contains('is-open');
        var isButton = trigger.tagName === 'BUTTON';
        // Buttons always toggle. Links: on touch devices the first tap opens, the second follows the link.
        if (isButton || (!canHover && !isOpen)) {
          event.preventDefault();
          setOpen(li, !isOpen);
        }
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setOpen(li, true);
          var first = li.querySelector('.pfmm__panel a, .pfmm__panel button');
          if (first) first.focus();
        }
      });

      li.addEventListener('focusout', function (event) {
        if (!li.contains(event.relatedTarget)) setOpen(li, false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && openItem) {
        var trigger = openItem.querySelector('.pfmm__top');
        setOpen(openItem, false);
        if (trigger) trigger.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (openItem && !root.contains(event.target)) setOpen(openItem, false);
    });

    // Start loading the image tiles as soon as the shopper reaches for the menu, so they are ready on open.
    // v6.2: menu photos ship with data-pfmm-src/srcset so they never compete with the page's own images on load.
    function hydrate(scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('img[data-pfmm-src]'), function (img) {
        var set = img.getAttribute('data-pfmm-srcset');
        if (set) img.setAttribute('srcset', set);
        img.setAttribute('src', img.getAttribute('data-pfmm-src'));
        img.removeAttribute('data-pfmm-srcset');
        img.removeAttribute('data-pfmm-src');
      });
    }
    function warmTiles() {
      hydrate(root);
      // v6.3: only fetch eagerly what the layout actually renders. Feature cards hidden on narrow or short screens
      // (display: none) stay lazy, so they are never downloaded there.
      Array.prototype.forEach.call(root.querySelectorAll('img[loading="lazy"]'), function (img) {
        if (img.getClientRects().length) img.loading = 'eager';
      });
      root.removeEventListener('mouseenter', warmTiles);
      root.removeEventListener('focusin', warmTiles);
      root.removeEventListener('touchstart', warmTiles);
    }
    root.addEventListener('mouseenter', warmTiles);
    root.addEventListener('focusin', warmTiles);
    root.addEventListener('touchstart', warmTiles, { passive: true });
    // Desktop only: once the page has finished loading and gone idle, fetch the menu photos so the first open is instant.
    function idleWarm() {
      setTimeout(function () {
        if (!root.getClientRects().length) return;   // desktop bar hidden (mobile layout): never download them
        if (window.requestIdleCallback) window.requestIdleCallback(warmTiles, { timeout: 4000 }); else warmTiles();
      }, 2500);
    }
    if (canHover) {
      if (document.readyState === 'complete') idleWarm(); else window.addEventListener('load', idleWarm);
    }

    fitTop();
    window.addEventListener('load', fitTop);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTop);
    // Web fonts can swap in late and widen the labels: refit whenever a top item changes size.
    if (window.ResizeObserver) {
      var fitTimer = null;
      var ro = new ResizeObserver(function () { clearTimeout(fitTimer); fitTimer = setTimeout(fitTop, 80); });
      Array.prototype.forEach.call(root.children, function (li) { ro.observe(li); });
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        fitTop();
        // Closed panels drop any stale full-width offsets so they can never widen the page.
        Array.prototype.forEach.call(root.querySelectorAll('.pfmm__panel'), function (p) {
          if (!openItem || p.parentNode !== openItem) { p.style.left = ''; p.style.right = ''; }
        });
        if (openItem) layout(openItem);
      }, 150);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pfmm]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when the header section is reloaded in the theme editor.
  document.addEventListener('shopify:section:load', boot);
})();
